module.exports = __webpack_public_path__ + "img/sale_banner4.ef83d2d5.png";